import React, { ReactNode } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Button } from '@/components/Buttons';
import { TranslatableText } from '@/types';

interface ConfirmDialogProps {
    title: ReactNode;
    body: ReactNode;
    confirmText?: TranslatableText;
    show: boolean;
    onConfirm(): void;
    onClose(): void;
    onCancel?(): void;
    isLoading?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    title,
    body,
    confirmText,
    show,
    onClose,
    onConfirm,
    onCancel,
    isLoading = false,
}) => {
    const handleAcceptClick = () => {
        triggerHandler(onConfirm);
    };

    const handleCancelClick = () => {
        triggerHandler(onCancel);
        triggerHandler(onClose);
    };

    return (
        <Modal isOpen={show} toggle={handleCancelClick}>
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>{body}</ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={handleCancelClick}>
                    <Trans>Cancel</Trans>
                </Button>
                <Button color="primary" loading={isLoading} onClick={handleAcceptClick}>
                    {confirmText ?? t`Confirm`}
                </Button>
            </ModalFooter>
        </Modal>
    );
};
